import { AnimationShell, Button } from "@/components";
import { useTranslation } from "react-i18next";

export function OfferDrawerFooter({
  canAct,
  onAccept,
  onDecline,
  onClose,
}: {
  canAct: boolean;
  onAccept: () => void;
  onDecline: () => void;
  onClose: () => void;
}) {
  const { t } = useTranslation(['offers']);

  return (
    <div className="flex w-full justify-end">
      <AnimationShell type="opacity" className="flex space-x-4" delay={0.5}>
        {canAct && (
          <>
            <Button size="md" color="primary" icon="check" onClick={onAccept}>
              {t('Accept offer')}
            </Button>
            <Button size="md" color="secondary" icon="thumb-down" onClick={onDecline}>
              {t('Decline offer')}
            </Button>
          </>
        )}
      </AnimationShell>
      <div>
        <Button size="md" color="neutral" onClick={onClose} className="ml-4 h-10">
          {t('Close')}
        </Button>
      </div>
    </div>
  );
}
